import { cva } from 'class-variance-authority';

export const wrapperClasses = cva(
  [
    'rounded-lg-alt bg-white-50 border-charcoal-alpha-50 relative flex h-auto w-full cursor-text flex-row items-center gap-2 border-1 border-solid p-4'
  ],
  {
    variants: {
      disabled: {
        true: ['cursor-not-allowed opacity-50 [&>*]:cursor-not-allowed'],
        false: ['cursor-text']
      },
      validationStatus: {
        undefined: ['border-charcoal-alpha-50'],
        true: ['border-success-900'],
        false: ['border-danger-500']
      }
    },
    defaultVariants: {
      validationStatus: 'undefined'
    }
  }
);

export const textareaExtraClasses = cva(['cursor-text transition-all ease-in-out'], {
  variants: {
    isFocused: {
      true: ['opacity-100'],
      false: ['opacity-0']
    }
  }
});

export const textareaClasses = cva(
  [
    'peer bg-white-50 text-charcoal-500 text-medium h-full w-full cursor-text resize-none border border-1 border-none text-[14px] tracking-[-0.3px] focus:outline-none',
    'placeholder:text-charcoal-50 placeholder:text-normal placeholder:'
  ],
  {
    variants: {
      variant: {
        default: [''],
        fluid: ['']
      },
      isFocused: {
        true: '', //['placeholder:opacity-100'],
        false: '' //['placeholder:opacity-0'],
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export const clearButtonClasses = cva(['text-charcoal-500 cursor-pointer'], {
  variants: {
    hasInputValue: {
      true: ['block'],
      false: ['hidden']
    }
  }
});
